import React, {useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSkillSetByDepartment } from "../../../Redux/Actions/skill_matrix_actions";
//import { MultiSelect } from 'react-multi-select-component';

  const GroupSelector = ({handleChange,group_id,department_id}) => {
  const dispatch = useDispatch();
  const { skillSetWithDepartment } = useSelector((state) => state.skillMatrix);


  useEffect(() => {
    dispatch(getSkillSetByDepartment(department_id));
  }, [department_id]);
  
  return (
    <div class="form-blk row">
      <div class="form-label">Skill Set</div>
      <div class="form-input">
      
      {/* <pre>{JSON.stringify(selected)}</pre>
      <MultiSelect
        options={options}
        value={selected}
        onChange={setSelected}
      /> */}
        <select
          class="form-select select2"
          name="group_id"
          onChange={handleChange}
          value={group_id}
        >

          <option value={null}>Select Skill Set</option>
          {skillSetWithDepartment &&
            skillSetWithDepartment.length &&
            skillSetWithDepartment.map((skillSet, i) => {
              return (
                <option key={i} value={skillSet.id}>
                  {skillSet.name}
                </option>
              );
            })}
        </select>
      </div>
     
    </div>
  );
};

export default GroupSelector;
